import Coverage from '@root/auto-pricing/src/models/coverage';
import CoverageGroup from '@root/quotes/src/components/coverage-options/coverage-group';
import PipNjCards from '@root/quotes/src/components/coverage/pip-nj-cards';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';

export default function CoverageSectionNjPip({
  cardHeaderBackgroundColor,
  coverageSelections,
  customQuote,
  dropdownIndicator,
  infoBrandColor,
  mobileSelectedOptionStyles,
  onCoverageChange,
  onCoverageSelectClose,
  onCoverageSelectOpen,
  optionStyles,
  primaryBrandColor,
  quotesContext,
  secondaryBrandColor,
  selectBoxFocusedStyles,
  selectBoxStyles,
  styleOverrides,
}) {
  if (quotesContext.market !== 'NJ') {
    return null;
  }

  const [pipCoverage] = customQuote.getOrderedCoveragesWithOptionsBySymbols(
    [Coverage.Symbols.PERSONAL_INJURY_PROTECTION],
    coverageSelections
  );

  if (!pipCoverage) {
    return null;
  }

  const [extMedCoverage] = customQuote.getOrderedCoveragesWithOptionsBySymbols(
    [Coverage.Symbols.MEDICAL_PAY],
    coverageSelections
  );

  return (
    <CoverageGroup
      heading={'Personal Injury Protection (PIP)'}
      styleOverrides={styleOverrides}
    >
      <PipNjCards
        cardHeaderBackgroundColor={cardHeaderBackgroundColor}
        coverage={pipCoverage}
        coverageSelections={coverageSelections}
        dropdownIndicator={dropdownIndicator}
        extMedCoverage={extMedCoverage}
        infoBrandColor={infoBrandColor}
        mobileSelectedOptionStyles={mobileSelectedOptionStyles}
        onCoverageChange={onCoverageChange}
        onCoverageSelectClose={onCoverageSelectClose}
        onCoverageSelectOpen={onCoverageSelectOpen}
        optionStyles={optionStyles}
        primaryBrandColor={primaryBrandColor}
        secondaryBrandColor={secondaryBrandColor}
        selectBoxFocusedStyles={selectBoxFocusedStyles}
        selectBoxStyles={selectBoxStyles}
      />
    </CoverageGroup>
  );
}

CoverageSectionNjPip.propTypes = {
  cardHeaderBackgroundColor: PropTypes.string,
  coverageSelections: PropTypes.object.isRequired,
  customQuote: PropTypes.object.isRequired,
  dropdownIndicator: PropTypes.string,
  infoBrandColor: PropTypes.string,
  mobileSelectedOptionStyles: PropTypes.object,
  onCoverageChange: PropTypes.func.isRequired,
  onCoverageSelectClose: PropTypes.func.isRequired,
  onCoverageSelectOpen: PropTypes.func.isRequired,
  optionStyles: PropTypes.object,
  primaryBrandColor: PropTypes.string,
  quotesContext: PropTypes.object.isRequired,
  secondaryBrandColor: PropTypes.string,
  selectBoxFocusedStyles: PropTypes.object,
  selectBoxStyles: PropTypes.object,
  styleOverrides: PropTypes.object,
};
